export const fixWindowsPath = (path) => path.replace(/\\/g, '/');
//# sourceMappingURL=fix-windows-path.js.map